import React, { useContext, useState } from 'react';
import CustomerProductContext from '../../ContextFiles/CustomerProductContext';
import WalmartImageSelectionModal from './WalmartImageSelectionModal';
import ShopifyUploadModal from './ShopifyUploadModal';
import ShopifyImageSelectionModal from './ShopifyImageSelectionModal';
import { Breadcrumb, Tooltip, Row, Col, Button, Dropdown, Menu } from 'antd';
import { ArrowLeftOutlined, DownOutlined, FlagOutlined, LinkOutlined, ShareAltOutlined } from '@ant-design/icons';
import { Header } from 'antd/lib/layout/layout';
import './ProductComponents.scss'
import ENVIRONMENT from '../../../../environments';
import { getBaseURL } from '../../../../environments/env';
import FileConstants from '../../../../FileConstants';

const CUSTOMER_USERNAME = localStorage.getItem('username');
const AMAZON_AUTHORIZED = localStorage.getItem('amazon_authorized') == 'true' ? true : false;
const WALMART_AUTHORIZED = localStorage.getItem('walmart_authorized') == 'true' ? true : false;
const SHOPIFY_AUTHORIZED = localStorage.getItem('shopify_authorized') == 'true' ? true : false;
const IS_MSPROVIDER = localStorage.getItem('is_msprovider');
const COMPANY_ID = localStorage.getItem('company_id');
const MANAGED_CUSTOMER_USERNAME = localStorage.getItem('managed_customer_username');
const MANAGED_COMPANY_ID = localStorage.getItem('managed_company_id');
const QUERY_PARAMS_TO_RETAIN = ['category', 'style', 'color', 'type', 'material', 'search', 'variant_of']
const ProductPageNavigation = () => {
    const { productAssetData, isStorePage, downloadImagesArchive, downloadSiloImages, openShareModal, product_id, amazonRequestInfo, setRejectionFeedbackModal, isAiModel,
        downloadCryptoImagesArchive, download360Frames, statusOf360Spin, openFlagModal, viewComplaintsListener, complaints, openAmazonReferenceImageSelectionModal, productData } = useContext(CustomerProductContext);

    const [walmartImageModalVisible, setWalmartImageModalVisible] = useState(false);
    const [shopifyModalVisible, setShopifyModalVisible] = useState(false);
    const [shopifyImageModalVisible, setShopifyImageModalVisible] = useState(false);

    const openWalmartImageSelectionModal = () => {
        setWalmartImageModalVisible(true);
    };

    const closeWalmartImageSelectionModal = () => {
        setWalmartImageModalVisible(false);
    };

    const openShopifyModal = () => {
        setShopifyModalVisible(true);
    };

    const closeShopifyModal = () => {
        setShopifyModalVisible(false);
    };

    const openShopifyImageModal = () => {
        setShopifyImageModalVisible(true);
    };

    const closeShopifyImageModal = () => {
        setShopifyImageModalVisible(false);
    };

    const tabNameMapping = {
        'active': 'Active Projects',
        'requested': 'Requested Projects',
        'approved': 'Approved Projects',
        'mspActive': 'Active Projects',
        'mspApproved': 'Approved Projects'
    }

    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("project_id")
    const projectName = urlParams.get("project_name")
    const projectTab = urlParams.get("projectTab")
    const selectedUser = urlParams.get("selectedUser")
    const viewProduct = () => {
        if (amazonRequestInfo && (amazonRequestInfo['status'] == 'REJECTED' || amazonRequestInfo['status'] == 'FAILED')) {
            setRejectionFeedbackModal(true);
        } else {
            if (amazonRequestInfo) {
                window.location.href = "https://www.amazon.com/dp/" + amazonRequestInfo['asin']
            } else {
                openAmazonReferenceImageSelectionModal();
            }
        }
    }
    const viewProductRejection = () => {
        if (amazonRequestInfo && (amazonRequestInfo['status'] == 'REJECTED' || amazonRequestInfo['status'] == 'FAILED')) {
            setRejectionFeedbackModal(true);
        }
    }
    const menu = (
        <Menu style={{ width: "200px" }}>
            <Menu.ItemGroup key={"assets"} title={<span className='manrope f-12 grey-8c'>Assets</span>} >
                <Menu.Item key={0}>
                    <div className='manrope f-14 black-55' onClick={() => downloadImagesArchive()}> All Images</div>
                </Menu.Item>
                {isAiModel == false &&
                <Menu.Item key={1}>
                    <div className='manrope f-14 black-55' onClick={() => downloadCryptoImagesArchive()}> Cryptomatte</div>
                </Menu.Item>}
                {productAssetData && productAssetData['silo_data']?.length > 0 && productAssetData['silo_data'].filter(ele => ele.image_status == 'completed').length > 0 &&
                    <Menu.Item key={2}>
                        <div className='manrope f-14 black-55' onClick={() => downloadSiloImages()}> Silo Images</div>
                    </Menu.Item>}
                {statusOf360Spin == "completed" ?
                    <Menu.Item key={3}>
                        <div className='manrope f-14 black-55' onClick={() => download360Frames()}> 360 Frames</div>
                    </Menu.Item> : ''}
            </Menu.ItemGroup>
            {productAssetData?.download_links && productAssetData?.download_links?.length > 0 &&
                <Menu.ItemGroup key={"model"} title={<span className='manrope f-12 grey-8c'>Model</span>} >
                    {(productAssetData.download_links || []).map((ele, index) => {
                        return (
                            <Menu.Item key={index + 3}>
                                <a className='manrope f-14' target="_blank"
                                    download
                                    href={ele.model_url.replace(ENVIRONMENT.DEFAULT_BASE_URL, getBaseURL(productAssetData['platform']))} >{ele.display_name}</a>
                            </Menu.Item>
                        );
                    })}
                    
                    {/* Custom Request Download Link - Show when status is 5 */}
                    {productData?.custom_request_status === 5 && (() => {
                        const customRequest = (productData?.custom_request || productData?.custom_request_type)?.toLowerCase();
                        if (!customRequest) return null;
                        
                        const fileConfig = FileConstants.CUSTOM_REQUEST_CONFIG[customRequest];
                        
                        if (fileConfig && fileConfig.merged_path) {
                            const basePath = ENVIRONMENT.getBaseURL(productData.platform || productAssetData?.platform || 'aws');
                            const fileName = product_id + fileConfig.extension;
                            const mergedPath = fileConfig.merged_path.endsWith('/') ? fileConfig.merged_path.slice(0, -1) : fileConfig.merged_path;
                            const fileUrl = basePath + encodeURIComponent(mergedPath + "/" + fileName);
                            
                            return (
                                <Menu.Item key="custom_request">
                                    <a className='manrope f-14' target="_blank"
                                        download
                                        href={fileUrl}>CUSTOM {customRequest?.toUpperCase()}</a>
                                </Menu.Item>
                            );
                        }
                        return null;
                    })()}
                </Menu.ItemGroup>}
        </Menu>
    );

    const amazonMenu = (
        <Menu style={{ width: "200px" }}>
            <Menu.Item key={1}>
                <Tooltip title={<span className='manrope f-12 white'>{AMAZON_AUTHORIZED && amazonRequestInfo ? FileConstants.amazon_request_status[amazonRequestInfo['status']] : 'Upload 3D Model'}</span>}>
                    <div className='manrope f-14 black-55' disabled={(amazonRequestInfo?.status == 'REJECTED' || amazonRequestInfo?.status == 'FAILED')} onClick={viewProduct}>Upload 3D Model</div>
                </Tooltip>
            </Menu.Item>
            <Menu.Item key={0}>
                <div className='manrope f-14 black-55' onClick={() => openAmazonReferenceImageSelectionModal('2d_image')}>Upload or Replace Images</div>
            </Menu.Item>
        </Menu>
    );

    const walmartMenu = (
        <Menu style={{ width: "200px" }}>
            <Menu.Item key={0}>
                <div className='manrope f-14 black-55' onClick={openWalmartImageSelectionModal}>Upload or Replace Images</div>
            </Menu.Item>
        </Menu>
    );


    const shopifyMenu = (
        <Menu style={{ width: "200px" }}>
            <Menu.Item key="single-upload" onClick={openShopifyModal}>
                <span className='manrope f-14 black-55'>Upload/Replace 3D Model</span>
            </Menu.Item>
            <Menu.Item key="upload-images" onClick={openShopifyImageModal}>
                <span className='manrope f-14 black-55'>Upload Images</span>
            </Menu.Item>
        </Menu>
    );


    const getLibraryUrl = () => {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        let queryString = ''
        let variantOf = '';
        for (const [key, value] of searchParams.entries()) {
            if (key != 'entity_id' && QUERY_PARAMS_TO_RETAIN.includes(key)) {
                if (key == 'variant_of') {
                    variantOf = encodeURIComponent(value)
                }
                else {
                    queryString = `${queryString}&${key}=${encodeURIComponent(value)}`
                }
            }
        }

        if (variantOf != '') {
            if (document.referrer === '' || document.referrer === null) {
                return `/products/${variantOf}?entity_id=${variantOf}`;
            }

            return document.referrer;
        }

        return '/list-products?entity_id=' + product_id + queryString;
    }



    return (
        <>
            <Header className='product-nav-header'>
                <Row className='display-flex j-s-b a-c'>
                    <Col span={12}>
                        <Breadcrumb className='display-flex j-s a-c'>
                            {projectName && projectId ?
                                <>
                                    <Breadcrumb.Item className="manrope f-14 lh-28 black-73 white-space-text">
                                        <a
                                            className="manrope f-14 lh-28 black-73 white-space-text"
                                            href={projectTab === "approved" || projectTab === "mspApproved" ? `/library-projects?tab=${projectTab}` : `/projects?tab=${projectTab}`}
                                        >
                                            <ArrowLeftOutlined className='mr-8' />
                                            {IS_MSPROVIDER && MANAGED_CUSTOMER_USERNAME && (projectTab == 'mspActive' || projectTab == 'mspApproved') ? `${MANAGED_CUSTOMER_USERNAME}'s ${tabNameMapping[projectTab]}` : `Your ${tabNameMapping[projectTab]}`}
                                        </a>
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item className="manrope f-14 lh-28 black-73 white-space-text">
                                        <a
                                            className="manrope f-14 lh-28 black-73 white-space-text"
                                            href={`/projects/${projectId}?tab=${projectTab}&selectedUser=${selectedUser}`}
                                        >
                                            {projectName.substring(0, 15) + (projectName.length > 15 ? '...' : '')}
                                        </a>
                                    </Breadcrumb.Item></>
                                :
                                <Breadcrumb.Item>
                                    <a className='manrope f-14 lh-28 black-73 white-space-text'
                                        href={isStorePage ? '/store' : getLibraryUrl()}>
                                        <ArrowLeftOutlined className='mr-8' />
                                        {isStorePage ? "Store" : "Product Library"}
                                    </a>
                                </Breadcrumb.Item>}
                            <Breadcrumb.Item className='manrope f-14 lh-28 black-d9 limit-lines limit-1'>{productAssetData['product_name']}</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col span={12} className='display-flex j-e a-c'>
                        {isAiModel == false && AMAZON_AUTHORIZED && amazonRequestInfo &&
                            <Tooltip title={<span className='manrope f-12 white'>{FileConstants.amazon_request_status[amazonRequestInfo['status']]}</span>}>
                                <span onClick={viewProductRejection}>
                                    {FileConstants.amazon_request_icon[amazonRequestInfo['status']]}
                                </span>
                            </Tooltip>}
                        {isAiModel == false && AMAZON_AUTHORIZED &&
                            <Tooltip title={<span className='manrope f-12 white'>Upload your product on amazon</span>}>
                                <Dropdown overlay={
                                    amazonMenu
                                } trigger={['click']} className='ml-16'>
                                    <Button style={{ padding: "0px 10px" }} className="nav-btns light-blue f-14 ml-16">
                                        <img className='amz-logo-dimensions' src={require("../../../../assets/images/aws-logo.svg")} alt="aws-logo"></img>
                                    </Button>
                                </Dropdown>
                            </Tooltip>}
                        {!isStorePage && (complaints && complaints.length > 0) && (productAssetData.is_store_item == -1 || productAssetData.customer_username == CUSTOMER_USERNAME)
                            &&
                            <Tooltip title={
                                <span className='manrope f-12 white'>Complaint History</span>
                            }>
                                <Button ghost
                                    onClick={viewComplaintsListener}
                                    className="nav-btns grey f-14 ml-16"
                                    icon={<img className="complaint-icon" src="/img/view-complaints.svg" />}
                                />
                            </Tooltip>}
                        {isAiModel == false && !isStorePage && productAssetData['silo_data']?.length > 0 && productAssetData['silo_data'].filter(ele => ele.image_status == 'completed').length > 0
                            && <Tooltip title={
                                <span className='manrope f-12 white'>Flag if unhappy</span>
                            }>
                                <Button ghost
                                    onClick={openFlagModal}
                                    className="nav-btns red f-14 ml-16"
                                    icon={<FlagOutlined />}
                                />
                            </Tooltip>}
                        {!isStorePage && <Tooltip title={
                            <span className='manrope f-12 white'>Share product</span>
                        }>
                            <Button ghost
                                onClick={openShareModal}
                                className="nav-btns light-blue f-14 ml-16"
                                icon={<LinkOutlined />}
                            >
                                Share
                            </Button>
                        </Tooltip>}
                        {!isStorePage && <Dropdown overlay={
                            menu
                        } trigger={['click']} className='ml-16'>
                            <Button className='product-btn light-blue f-14 br-2' ghost>Download <DownOutlined /></Button>
                        </Dropdown>}
                        {isAiModel == false && WALMART_AUTHORIZED && (
                            <Tooltip title={<span className='manrope f-12 white'>Upload your product on Walmart</span>}>
                                <Dropdown overlay={walmartMenu} trigger={['click']} className='ml-16'>
                                    <Button style={{ padding: "0px 10px" }} className="nav-btns light-blue f-14 ml-16">
                                        <img className='walmart-logo-dimensions' src={require("../../../../assets/images/walmart_logo.svg")} alt="walmart-logo" />
                                    </Button>
                                </Dropdown>
                            </Tooltip>
                        )}
                        {isAiModel == false && WALMART_AUTHORIZED && (
                            <WalmartImageSelectionModal
                                visible={walmartImageModalVisible}
                                onCancel={closeWalmartImageSelectionModal}
                            />
                        )}
                        {isAiModel == false && SHOPIFY_AUTHORIZED && (
                            <Tooltip title={<span className='manrope f-12 white'>Upload or Replace your 3D model on Shopify</span>}>
                                <Dropdown overlay={shopifyMenu} trigger={['click']} className='ml-16'>
                                    <Button style={{ padding: "0px 10px" }} className="nav-btns light-blue f-14 ml-16">
                                        <img className='walmart-logo-dimensions' src={require("../../../../assets/images/shopify-logo-2018.svg")} alt="walmart-logo" />
                                    </Button>
                                </Dropdown>
                            </Tooltip>
                        )}
                        {isAiModel == false && SHOPIFY_AUTHORIZED && (
                            <ShopifyUploadModal
                                visible={shopifyModalVisible}
                                onCancel={closeShopifyModal}
                                productId={product_id}
                            />
                        )}
                        {SHOPIFY_AUTHORIZED && (
                            <ShopifyImageSelectionModal
                                visible={shopifyImageModalVisible}
                                onCancel={closeShopifyImageModal}
                                productId={product_id}
                            />
                        )}
                    </Col>

                </Row>
            </Header>
        </>
    )
}

export default ProductPageNavigation;
